/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable max-len */
import React from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';

function OrderConfirmModal({ handlePlaceOrder, setCreatePopup, createPopup }) {
    return (
        <div className="modal fade fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto" id="place-order-alert" tabIndex="-1" aria-labelledby="removefromWishes" aria-modal="true" role="dialog">
            <div className="modal-dialog modal-dialog-centered relative pointer-events-none sm:max-w-[400px] w-full px-3 mx-auto" style={{ margin: 'auto' }}>
                <div className="modal-content shadow-s8 border-none relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between sm:p-5 pb-4 pt-6 px-1 rounded-t-md">
                        <h5 className="text-lg font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel2">
                            Place Order
                        </h5>
                        <div className="top-[14px] right-[14px] absolute cursor-pointer">
                            <img
                                src="/images/Icon-ionic-ios-close.svg"
                                alt=""
                                onClick={() => setCreatePopup(false)}
                            />
                        </div>
                    </div>
                    <div className="modal-body relative sm:px-7 px-3 sm:pt-1 pt-0 sm:pb-6 pb-4 text-center">
                        <p className="text-xs6 font-normal text-[#555259] sm:pb-6 pb-3">
                            Are you sure you want to place this order?
                        </p>
                    </div>
                    <div className="modal-footer flex flex-shrink-0 flex-wrap justify-evenly sm:pb-5 pb-4 rounded-b-md">
                        <button type="button" onClick={(e) => handlePlaceOrder(e, false)} className="border border-[#555259] bg-[#ffffff] sm:text-xs6 text-sm font-normal text-[#555259] sm:py-3 py-2 sm:px-9 px-6 rounded-lg" data-bs-dismiss="modal" aria-label="Close">
                            No, save as draft
                        </button>
                        <button type="button" onClick={(e) => handlePlaceOrder(e, true)} className="bg-[#555259] font-normal text-[#ffffff] sm:text-xs6 text-sm sm:py-3 py-2 sm:px-12 px-9 rounded-lg place-order-btn" data-bs-toggle="modal" data-bs-target="#orderPlaced">
                            Yes
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default OrderConfirmModal;
